const DRAWER_OPEN = (state, bool) => {
  state.drawerOpen = bool
}

const ALERT = (state, obj) => {
  state.alert = obj
}

const LOADER = (state, obj) => {
  state.loader = obj
}

const CURRENT_MODULE = (state, obj) => {
  state.currentModule = obj
}

const CURRENT_PATH = (state, obj) => {
  state.currentPath = obj
}

const AXIOS_HIDE_LOADER = (state, obj) => {
  state.axiosHideLoader = obj
}

const NEW_VERSION_SNACKBAR = (state, obj) => {
  state.newVersionSnackbar = obj
}

const ROUTE_COUNT = (state, obj) => {
  state.routeCount = obj
}

const VERSION_CHECK = (state, obj) => {
  state.versionCheck = obj
}

export default {
  DRAWER_OPEN,
  ALERT,
  LOADER,
  CURRENT_MODULE,
  CURRENT_PATH,
  AXIOS_HIDE_LOADER,
  NEW_VERSION_SNACKBAR,
  ROUTE_COUNT,
  VERSION_CHECK
}
